export const initialState = {
  localizationFilters:{
    cultureCode: "-1",
    appId:-1,
    keyword:"",
    page:0,
    pageSize:20
   },
   updatedKeyword:{
    keyword:""
   }
  }